import React from 'react';
import { useGetCloser } from './hooks/useGetCloser';
import { ErrorMessageTW } from '../../../../../../tailwindComponents/errorMessage/ErrorMessageTW';

export const CloserAlert: React.FC = () => {
  const { assignedCloser, isSuccess } = useGetCloser();
  if (isSuccess && assignedCloser) {
    return null;
  }
  return <ErrorMessageTW message={`Associate a closer contact to this payment request to send.`} />;
};
